// extracted by mini-css-extract-plugin
export default {"ToggleBtn":"ToggleBtn_ToggleBtn__SFJs-","ToggleBtn__Input":"ToggleBtn_ToggleBtn__Input__-4IcE"};